import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  BillingsService,
  GetBillToAccountsResponse,
  GetBrandBillingConfigResponse,
} from 'src/app/core/proto';
import {
  actionBillToAccountsGet,
  actionBillToAccountsGetSuccess,
  actionBillToAccountsGetFailure,
  actionBrandConfigBillingsGet,
  actionBrandConfigBillingsGetSuccess,
  actionBrandConfigBillingsGetFailure,
} from 'src/app/core/store/billings/billings.action';
import { AppState } from '../../reducers';
import { isOxioAdmin } from 'src/app/core/store/account/account.selectors';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class BillingsEffects {
  isOxioAdmin: boolean;

  constructor(
    private billingsService: BillingsService,
    private store: Store<AppState>,
    private actions$: Actions
  ) {
    this._isOxioAdmin();
  }

  _isOxioAdmin() {
    this.store
      .pipe(select(isOxioAdmin), untilDestroyed(this))
      .subscribe((isOxioAdmin: boolean) => {
        this.isOxioAdmin = isOxioAdmin;
      });
  }

  getBillToAccounts$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(actionBillToAccountsGet),
      switchMap((params) => {
        return this.billingsService
          .getBillToAccounts(params.getBillToAccountsParams)
          .pipe(
            map(
              (getBillToAccountsResponse: GetBillToAccountsResponse) => {
                return actionBillToAccountsGetSuccess({
                  billToAccounts: getBillToAccountsResponse?.billToAccounts,
                  billToAccountsBrand: this.isOxioAdmin
                    ? getBillToAccountsResponse.billToAccounts
                    : getBillToAccountsResponse.billToAccounts?.filter(
                        (billToAccount) => !billToAccount.name.includes('OXIO')
                      ),
                });
              },
              catchError(() => of(actionBillToAccountsGetFailure()))
            )
          );
      })
    );
  });

  getBrandBillingConfig$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(actionBrandConfigBillingsGet),
      switchMap((params) => {
        return this.billingsService
          .getBrandBillingConfig(params.getBrandBillingConfigParams)
          .pipe(
            map(
              (
                getBrandBillingConfigResponse: GetBrandBillingConfigResponse
              ) => {
                return actionBrandConfigBillingsGetSuccess({
                  payload: getBrandBillingConfigResponse,
                });
              },
              catchError(() => of(actionBrandConfigBillingsGetFailure()))
            )
          );
      })
    );
  });
}
